var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((['fr', 'en']),function(locale){return [(_vm.$i18n.locale !== locale)?_c('v-btn',{key:locale,attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.changeLocaleTo(locale)}}},[_vm._v(_vm._s(_vm.$t(`locales.${locale}`)))]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }